import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

class GateDocumentServices {
  createGateDocument = async (payload) => {
    const gateDoc = await Helpers.post({
      url: Constants.GATE_DOCUMENT,
      data: payload,
    });
    return gateDoc;
  }

  getGateDocumentById = async ({ documentId }) => {
    let url = `${Constants.GATE_DOCUMENT}?`;
    if (documentId) url += `gate_document_id=${documentId}&`;
    const getGateDoc = await Helpers.get({ url });
    return getGateDoc;
  }

  getGateDocuments = async ({
    tenantId, page, limit, status, startDate, endDate, keyword, documentType, customerIds, sellerIds,
  }) => {
    let url = `${Constants.GATE_DOCUMENT}/list?`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}&`;
    if (status) url += `status=${status}&`;
    if (startDate) url += `document_time_start=${startDate}&`;
    if (endDate) url += `document_time_end=${endDate}&`;
    if (keyword) url += `search_keyword=${keyword}&`;
    if (documentType) url += `gate_document_type=${documentType}&`;
    if (customerIds) url += `customer_ids=${customerIds}&`;
    if (sellerIds) url += `seller_ids=${sellerIds}&`;
    const listGateDoc = await Helpers.get({ url });
    return listGateDoc;
  }

  linkContacts = async (payload) => {
    const url = `${Constants.GATE_DOCUMENT}/link-contact`;
    const linkDoc = await Helpers.post({
      url,
      data: payload,
    });
    return linkDoc;
  }

  unlinkContacts = async (payload) => {
    const url = `${Constants.GATE_DOCUMENT}/unlink-contact`;
    const unlinkDoc = await Helpers.put({
      url,
      data: payload,
    });
    return unlinkDoc;
  }

  linkDocuments = async (payload) => {
    const url = `${Constants.GATE_DOCUMENT}/link-document`;
    const linkDoc = await Helpers.post({
      url,
      data: payload,
    });
    return linkDoc;
  }

  unlinkDocuments = async (payload) => {
    const url = `${Constants.GATE_DOCUMENT}/unlink-document`;
    const unLinkDoc = await Helpers.put({
      url,
      data: payload,
    });
    return unLinkDoc;
  }

  updateDocumentStatus = async (payload) => {
    const url = `${Constants.GATE_DOCUMENT}/status`;
    const updateStatus = await Helpers.put({
      url,
      data: payload,
    });
    return updateStatus;
  }

  quickUpdateGateDocument = async (payload) => {
    const url = `${Constants.GATE_DOCUMENT}/quick-update`;
    const updateStatus = await Helpers.put({
      url,
      data: payload,
    });
    return updateStatus;
  }
}

export default new GateDocumentServices();
